import { Button, DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger, Icon } from "@/shared/components";
import { Row, RowData } from "@tanstack/react-table";
import type { DataTableFeatures } from "./data-table-features";

type DataTableRowActionsProps<TData extends RowData> = {
    row: Row<DataTableFeatures, TData>;
    onDelete?: (item: TData) => void;
    onEdit?: (item: TData) => void;
};

export function DataTableRowActions<TData extends RowData>({ row, onDelete, onEdit }: DataTableRowActionsProps<TData>) {
    return (
        <DropdownMenu>
            <DropdownMenuTrigger asChild data-testid="table-row-actions">
                <Button icon="menu-overflow-horizontal" variant="tertiary" aria-label="Open menu" data-testid="open-menu">
                    <span className="sr-only">Open menu</span>
                </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" data-testid="table-row-actions">
                <DropdownMenuItem onClick={() => onEdit?.(row.original)} className="text-primary" data-testid="edit-vestiging">
                    <Icon name="edit" className="mr-2" size="xs" />
                    Bewerken
                </DropdownMenuItem>
                {onDelete && (
                    <DropdownMenuItem onClick={() => onDelete?.(row.original)} className="text-destructive" data-testid="delete-vestiging">
                        <Icon name="trash" className="mr-2" size="xs" />
                        Verwijderen
                    </DropdownMenuItem>
                )}
            </DropdownMenuContent>
        </DropdownMenu>
    );
}
